import React from 'react';
import { useRouter } from 'next/router';
import {
  SelectTrigger,
  SelectValue,
  Select,
  SelectContent,
  SelectItem,
} from '@/components/shadcn/select.tsx';
import { menu, tosPage } from '@/utils/tos';

interface Props {
  page?: string;
}

const Nav = ({ page }: Props) => {
  const router = useRouter();
  const placeholder = menu[(page as tosPage) || tosPage.mappingNetwork];

  return (
    <div>
      <Select
        defaultValue={placeholder.target}
        onValueChange={value =>
          router.push(value, undefined, { shallow: true })
        }>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={placeholder.title} />
        </SelectTrigger>
        <SelectContent>
          {Object.values(menu).map(item => (
            <SelectItem key={item.target} value={item.target}>
              {item.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default Nav;
